// extracted by mini-css-extract-plugin
export default {"Table-cell-item":"Table-cell-item__ZCLGoPuD+I"};